export enum JobsRoutingEnum {
  Offer = 'deposer-offre',
  Offers = 'offres-emploi',
  View = ':jobId',
}
